import { render, staticRenderFns } from "./auditBox.vue?vue&type=template&id=484654ca"
import script from "./auditBox.vue?vue&type=script&lang=js"
export * from "./auditBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports